import { hasAccountFlag, setAccountFlag } from "../../../utils/accountFlags";

/**
 * Le parcours de mise en route ne se propose qu'une fois. Le drapeau est posé aussi bien
 * quand l'éleveur le termine que lorsqu'il le passe, ou qu'on constate qu'il a déjà des
 * élevages — ce qui évite d'interroger l'API à chaque retour sur le dashboard.
 */
const FLAG = "setup-resolved";

export const isSetupResolved = (): boolean => hasAccountFlag(FLAG);

export const markSetupResolved = () => setAccountFlag(FLAG);
